import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {JourneyService} from '../service/journey.service';
import {JourneyDelegateTemplateModel, JourneyPageModel} from '../models/journey-page.model';
import {fadeInOnEnterAnimation} from 'angular-animations';
import {AuthService} from '../../../services/auth.service';
import {UserInfoModel} from '../../../services/models/user-info.model';
import {UserService} from '../../../services/user.service';
import {AlertController, IonSlides} from '@ionic/angular';
import {AnalyticsService} from '../../../services/analytics.service';
import {TranslateService} from '@ngx-translate/core';
import {EventsService} from '../../../services/events.service';
import {environment} from '../../../../environments/environment';
import {NavService} from '../../../services/nav.service';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-learning-journey-stage-page',
    templateUrl: './journey-stage-page.component.html',
    styleUrls: ['./journey-stage-page.component.scss'],
    animations: [fadeInOnEnterAnimation({anchor: 'enter', duration: 300})]
})
export class JourneyStagePage implements OnInit {
    subscriptions: Subscription[] = [];

    backRoute: any[] = ['/home'];

    stage_id = 0;
    template_id = 0;

    isSaveList = false;
    isSaveProgram = false;

    customListData: Array<any> = [];

    isFirstLoad = true;
    isLoading = true;
    isError = false;
    pageData: JourneyPageModel = null;
    saveForm = false;

    userInfo: UserInfoModel = null;

    platform = 'website';
    theme = 'default';

    constructor(
        private journeyService: JourneyService,
        private activatedRoute: ActivatedRoute,
        public userService: UserService,
        private alertController: AlertController,
        private translate: TranslateService,
        private event: EventsService,
        private nav: NavService,
    ) {
        this.platform = environment.platform;
        this.theme = environment.theme;
    }

    ngOnInit() {
        this.template_id = parseInt(this.activatedRoute.snapshot.paramMap.get('template_id'), 10);
        this.stage_id = parseInt(this.activatedRoute.snapshot.paramMap.get('stage_id'), 10);

        if (isNaN(this.template_id) || this.template_id < 1) {
            this.isLoading = false;
            this.isError = true;
            return;
        }
        if (isNaN(this.stage_id) || this.stage_id < 1) {
            this.isLoading = false;
            this.isError = true;
            return;
        }

        this.userInfo = this.userService.getCurrentUserInfo(false);
        if (this.userInfo !== null) {
            this.initPageData();
        } else {
            this.userService.getUserInfo()
                .then((userInfo) => {
                    this.userInfo = userInfo;
                    this.initPageData();
                });
        }
    }

    initPageData() {
        this.journeyService.getStageData(this.stage_id, this.template_id)
            .then(data => {
                this.isLoading = false;
                this.isFirstLoad = false;
                if (!!data) {
                    this.pageData = data;
                } else {
                    this.isError = true;
                    this.isLoading = false;
                    return false;
                }
            });
    }

    onSave() {
        this.saveForm = false;
        setTimeout(() => {
            this.saveForm = true;
            this.isSaveProgram = false;
        });
    }

    discardChanges() {
        if (this.isSaveProgram) {
            this.isSaveProgram = false;
            this.reloadPageData();
        }

        if (this.isSaveList) {
            this.isSaveList = false;
            this.customListData = [];
            this.reloadPageData();
        }
    }

    reloadPageData(initPageData = false) {
        this.pageData = null;
        if (initPageData) {
            console.log('reloadPageData > initPageData')
            this.initPageData();
        }
    }

    onChangeProgramSaveButton(value) {
        this.isSaveProgram = true;
    }

    onChangeListSaveButton(value) {
        this.event.publish('form:changed', 'journey:stage');
        this.customListData = this.customListData.filter(item => item.section_id !== value.section_id);
        this.customListData.push(value);
        this.isSaveList = true;
    }

    onSaveList() {
        if (this.customListData.length === 0) {
            this.event.publish('form:saved', {name: 'journeyStage'});
            return false;
        }

        this.journeyService.savePageData(this.customListData)
            .then(responce => {
                if (responce !== null) {
                    this.event.publish('form:saved', {name: 'journeyStage'});

                    this.isSaveList = false;
                    this.customListData = [];

                    this.alertController.create({
                        header: this.translate.instant('__ALERT_SUCCESS_TITLE__'),
                        message: this.translate.instant(responce.message),
                        buttons: [this.translate.instant('__ALERT_SUCCESS_BUTTON__')]
                    }).then(a => a.present());
                }
            })
            .catch(e => {

            });
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(i => i.unsubscribe());
    }
}
